<template>
  <div>
    <b-tabs class="nav-tabs custom-tabs-ce">
      <b-tab
        v-for="(tab, index) in tabs"
        :key="index"
        :title="tab.title"
        :disabled="tab.disabled"
      >
        <div v-if="index === 0" style="max-height: 490px; overflow-y: scroll;">
          <div class="container">
           <div class="form-group row orange-input-band">
              <div class="col-sm-6">
                <button
                  class="btn btn-outline-primary btn-block"
                  :disabled="deshabilitarBuscarProducto"
                  @click="abrirModalProducto"
                >
                  Buscar producto
                </button>
              </div>
              <div class="col-sm-6" v-if="tieneInsumoId">
                <button
                  :class="['btn', 'btn-block', insumoActivo ? 'btn-success' : 'btn-outline-primary']"
                  :disabled="stockVerificado || insumoActivo"
                  @click="abrirModalInsumo"
                >
                  Insumos Sugeridos
                </button>
              </div>
            </div>

            <!-- Alerta de stock insuficiente -->
            <div v-if="hayProductosConFaltante" class="alert alert-danger py-2 mb-2">
              <i class="nav-icon i-Warning1 mr-2"></i>
              <strong>Stock insuficiente:</strong>
              {{ productosConFaltante }}
            </div>

            <!-- Tabla de Insumos -->
            <div class="table-responsive">
              <table class="table table-bordered table-sm mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 5%;" class="text-center"></th>
                    <th style="width: 30%;">Producto</th>
                    <th style="width: 15%;" class="text-center">Lote</th>
                    <th style="width: 15%;" class="text-center">Cantidad</th>
                    <th style="width: 12%;" class="text-center">Origen</th>
                    <th style="width: 8%;" class="text-center">Ver</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, idx) in listaTablaInsumosVisibles">
                    <tr :key="'row-' + idx" :class="getRowClass(item)">
                      <td class="text-center">
                        <i
                          class="nav-icon i-Close-Window font-weight-bold text-danger"
                          style="cursor: pointer"
                          @click="eliminarInsumo(item)"
                          title="Eliminar"
                        ></i>
                      </td>
                      <td>
                        {{ item.Producto }}
                        <small v-if="item.numero_salida_producto" class="d-block text-muted">
                          {{ item.numero_salida_producto }}
                        </small>
                      </td>
                      <td class="text-center">
                        {{ item.lote || '-' }}
                      </td>
                      <td class="text-center">
                        {{ formatearNumero(item.cantidad) }}
                        <small class="text-muted ml-1">{{ item.unidad }}</small>
                      </td>
                      <td class="text-center">
                        <b-badge :variant="item.is_insumo === 1 ? 'info' : 'secondary'">
                          {{ item.is_insumo === 1 ? 'Insumo' : 'Producto' }}
                        </b-badge>
                      </td>
                      <td class="text-center">
                        <template v-if="item.lotes && item.lotes.length > 0">
                          <b-badge variant="secondary">{{ item.lotes.length }}</b-badge>
                          <b-button
                            size="sm"
                            variant="link"
                            class="p-0 ml-1"
                            @click="toggleLotesProducto(idx)"
                          >
                            {{ productoExpandido === idx ? 'Ocultar' : 'Ver' }}
                          </b-button>
                        </template>
                        <span v-else>-</span>
                      </td>
                    </tr>
                    <!-- Fila expandida con lotes -->
                    <tr
                      v-if="productoExpandido === idx && item.lotes && item.lotes.length > 0"
                      :key="'lotes-' + idx"
                    >
                      <td colspan="6" class="p-0 bg-light">
                        <div class="px-3 py-2">
                          <!-- Todos los lotes disponibles -->
                          <small class="text-muted font-weight-bold">
                            Lotes disponibles ({{ item.lotes.length }}):
                          </small>
                          <table class="table table-sm table-striped mb-0">
                            <thead>
                              <tr>
                                <th style="width: 30%;">Lote</th>
                                <th style="width: 25%;">Vencimiento</th>
                                <th style="width: 20%;">Disponibles</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(lote, li) in item.lotes"
                                :key="li"
                              >
                                <td>{{ lote.lote_numero }}</td>
                                <td>
                                  {{ lote.fecha_vencimiento
                                    ? formatDate(lote.fecha_vencimiento) : '-' }}
                                </td>
                                <td>{{
                                  formatearNumero(
                                    item.usar_unidad_secundaria
                                      ? lote.disponibles * (item.conversiones || 1)
                                      : lote.disponibles
                                  )
                                }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="listaTablaInsumos.length === 0">
                    <td colspan="6" class="text-center text-muted py-3">
                      No hay productos agregados
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="container mt-3 mb-3">
            <div class="row">
              <div class="col-sm-12 text-right">
                <button
                v-if="listaTablaInsumos.length > 0 && tienePendientes"
                  class="btn btn-secondary mr-2"
                  @click="verificarStock"
                  :disabled="loadingVerificarStock"
                >
                  <span v-if="loadingVerificarStock">
                    <b-spinner small></b-spinner> Verificando...
                  </span>
                  <span v-else>Verificar Stock</span>
                </button>
                <button
                  v-if="stockVerificado && tienePendientes"
                  class="btn btn-dark"
                  @click="entregarProductos"
                  :disabled="!puedeEntregar || loadingEntregarProductos"
                >
                  <span v-if="loadingEntregarProductos">
                    <b-spinner small></b-spinner> Procesando...
                  </span>
                  <span v-else>Dar de Baja Insumos</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="index === 1" style="max-height: 490px; overflow-y: scroll;">
                <div v-for="(item, index) in itemResumenes" :key="index" class="row mb-3" >
                    <div class="col-12 bordeResumen p-3" style="border-top: none !important;">
                        <div class="row" style="margin-top: -2%;">
                            <div class="col-12">
                                <b>N:</b> {{ item.numero_consulta }} -
                                <b>Fecha:</b> {{ formatDate(item.fecha) }} -
                                <b>Medico:</b> {{ item.medico }}
                            </div>
                        </div>
                        <div class="row mb-2" v-if="item.motivo">
                            <div class="col-12" style="line-height: 1;">
                                <b>Motivo:</b> {{ item.motivo }}
                            </div>
                        </div>
                        <div class="row mb-2" v-if="item.tratamiento">
                            <div class="col-12" style="line-height: 1;">
                                <b>Tratamiento:</b> {{ item.tratamiento }}
                            </div>
                        </div>
                        <div class="row mb-2" v-if="item.enfermedad">
                            <div class="col-12" style="line-height: 1;">
                                <b>Enfermedad:</b> {{ item.enfermedad }}
                            </div>
                        </div>

                    </div>
                </div>
        </div>
        <div v-if="index === 2" style="max-height: 490px; overflow-y: scroll;">
            <b-table
            class="table table-hover"
            :fields="fields"
            :items="listaTabla"
            >
                <template #cell(fecha)="item">
                    {{ formatDate(item.item.fecha) }}
                </template>
                <template #cell(opciones)="item">
                    <i
                    class="nav-icon i-File-Download font-weight-bold text-info cursor-pointer"
                    style="cursor: pointer"
                    @click="openModalPrint(item.item)"
                    ></i>
                </template>
            </b-table>
        </div>
      </b-tab>
    </b-tabs>
    <modalPrint
      :itemService="itemServicio"
      :selectedConsulta="selectedId"
      @open-modal="openModalPrint"
    />
    <ModalBuscarProducto
      :modelValue="showProductoModal"
      :almacen-id="almacenSelected ? almacenSelected.id : null"
      @update:modelValue="showProductoModal = $event"
      @seleccionar="seleccionarProducto"
    />

  </div>
</template>

<script>
import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';
import modalPrint from '../../asistenciaMedico/components/modalPrint.vue';
import ModalBuscarProducto from './ModalBuscarProducto.vue';

export default {
  name: 'TabDetalleCE',
  components: {
    modalPrint,
    ModalBuscarProducto,
  },
  props: {
    pacienteId: {
      type: Number,
      required: true,
    },
    almacen: {
      type: Array,
      required: true,
      default: () => [],
    },
    ordenTrabajoData: {
      type: Object,
      required: true,
    },
    almacenSelected: {
      type: Object,
      required: false,
      default: null,
    },
    medico_id: {
      type: [Number, String],
      required: true,
    },
    cierre: {
      type: Boolean,
      required: true,
    },
    // Props para datos del formulario padre (necesarios para guardar)
    clasificacionCie: {
      type: Object,
      default: null,
    },
    subclasificacionCie: {
      type: Object,
      default: null,
    },
    diagnostico: {
      type: String,
      default: '',
    },
    conclusion: {
      type: String,
      default: '',
    },
    enlaceInformacion: {
      type: String,
      default: '',
    },
    imagenesEliminar: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tabs: [
        { title: 'Insumos', disabled: false },
        { title: 'Resumen', disabled: false },
        { title: 'Detallado', disabled: false },
      ],
      fields: [
        {
          key: 'numero', label: 'N°', class: 'text-center', thClass: 'bg-light', thStyle: { width: '7%' },
        },
        {
          key: 'numero_consulta', label: 'N° C.E', class: 'text-center', thClass: 'bg-light', thStyle: { width: '8%' },
        },
        {
          key: 'tipo', label: 'Tipo', class: 'text-center', thClass: 'bg-light', thStyle: { width: '11%' },
        },
        {
          key: 'fecha', label: 'Fecha', class: 'text-center', thClass: 'bg-light', thStyle: { width: '9%' },
        },
        {
          key: 'medico', label: 'Médico', class: 'text-center', thClass: 'bg-light', thStyle: { width: '21%' },
        },
        {
          key: 'opciones', label: '', class: 'text-center', thClass: 'bg-light', thStyle: { width: '4%' },
        },
      ],
      fieldInsumo: [
        {
          key: 'opciones', label: '', class: 'text-center', thClass: 'bg-light', thStyle: { width: '4%' },
        },
        {
          key: 'Producto', label: 'Producto', class: 'text-center', thClass: 'bg-light', thStyle: { width: '7%' },
        },
        {
          key: 'lote', label: 'Lote/Venc.', class: 'text-center', thClass: 'bg-light', thStyle: { width: '8%' },
        },
        {
          key: 'cantidad', label: 'Cant./Unidad', class: 'text-center', thClass: 'bg-light', thStyle: { width: '11%' },
        },
      ],
      selectedId: null,
      listaTabla: [
      ],
      listaTablaInsumos: [
      ],
      itemServicio: null,
      itemResumenes: [],
      productos: [
      ],
      nuevoProducto: {
        producto: '',
        almacen: '',
        lote: '',
        cantidad: '',
        unidad: '',
      },
      listaProductos: [],
      showProductoModal: false,
      productoSelected: null,
      insumoActivo: false,
      stockVerificado: false,
      productoExpandido: null,
      loadingVerificarStock: false,
      loadingEntregarProductos: false,
    };
  },
  computed: {
    tieneInsumoId() {
      return this.ordenTrabajoData?.orden_trabajo?.insumo_id != null;
    },
    puedeEntregar() {
      if (!this.stockVerificado || this.listaTablaInsumos.length === 0) {
        return false;
      }
      const pendientes = this.listaTablaInsumos.filter(
        (item) => item.numero_salida_producto == null,
      );
      if (pendientes.length === 0) return false;
      const sinFaltantes = pendientes.every(
        (item) => !item.faltante || item.faltante === 0,
      );
      const todosConLotes = pendientes.every(
        (item) => (item.lotesPorTomar && item.lotesPorTomar.length > 0) || item.lote_id,
      );
      return sinFaltantes && todosConLotes;
    },
    hayProductosConFaltante() {
      return this.listaTablaInsumos.some((item) => item.faltante > 0);
    },
    productosConFaltante() {
      const productos = this.listaTablaInsumos
        .filter((item) => item.faltante > 0)
        .map((item) => `${item.Producto} (faltan ${item.faltante})`);
      return productos.join(', ');
    },
    // Verifica si ya hubo alguna entrega (tiene numero_salida_producto)
    yaEntregado() {
      return this.listaTablaInsumos.some((item) => item.numero_salida_producto != null);
    },
    // Verifica si hay items pendientes de entrega (sin numero_salida_producto)
    tienePendientes() {
      return this.listaTablaInsumos.some((item) => item.numero_salida_producto == null);
    },
    // Verifica si hay insumos agregados (is_insumo === 1)
    tieneInsumosAgregados() {
      return this.listaTablaInsumos.some((item) => item.is_insumo === 1);
    },
    // Verifica si hay productos agregados (is_insumo === 0)
    tieneProductosAgregados() {
      return this.listaTablaInsumos.some((item) => item.is_insumo === 0);
    },
    deshabilitarBuscarProducto() {
      if (this.yaEntregado) return false;
      return this.stockVerificado;
    },
    // Deshabilita "Insumos Sugeridos" si: no ha entregado Y ya tiene productos agregados
    deshabilitarInsumosSugeridos() {
      if (this.yaEntregado) return false; // Si ya entregó, puede mezclar
      if (this.stockVerificado) return true; // Si ya verificó stock, no puede agregar más
      return this.tieneProductosAgregados; // Si tiene productos, no puede agregar insumos
    },
    // Lista filtrada para mostrar solo items con estado activo
    listaTablaInsumosVisibles() {
      return this.listaTablaInsumos.filter((item) => item.estado !== false);
    },
  },
  created() {
    this.getServicioResumen();
    this.listarRegistros();
    // this.cargarAlmacenes(); // Los almacenes vienen del componente padre como prop
  },
  watch: {
    'ordenTrabajoData.orden_trabajo_detalle': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const desdeServidor = newVal.map((detalle) => ({
            id: detalle.tipo_producto_id,
            id_detalle: detalle.id,
            Producto: detalle.tipo_producto_nombre,
            descripcion: detalle.descripcion,
            numero_salida_producto: detalle.numero_salida_producto || null,
            lote: detalle.lote_numero || '',
            lote_id: detalle.lote_id,
            cantidad: detalle.cantidad,
            unidad_id: detalle.unidad_medida_id,
            unidad: detalle.unidad_medida_abreviatura,
            estado: true,
            is_insumo: detalle.is_insumo ?? 0,
            lotesPorTomar: detalle.lote_id ? [{ lote_id: detalle.lote_id }] : [],
            salida_producto_id: detalle.salida_producto_id,
            costo_unitario: detalle.costo_unitario || null,
            total: detalle.total || null,
          }));

          const agregadosLocalmente = this.listaTablaInsumos.filter(
            (local) => !desdeServidor.some(
              (s) => s.id === local.id && s.unidad_id === local.unidad_id,
            ),
          );

          this.listaTablaInsumos = [...desdeServidor, ...agregadosLocalmente];

          const tieneInsumos = newVal.some(
            (detalle) => detalle.is_insumo === 1,
          );
          if (tieneInsumos) {
            this.insumoActivo = true;
          }

          this.stockVerificado = false;

          this.emitirDetalles();
        }
      },
    },
  },
  methods: {
    async listarRegistros() {
      try {
        const RESPONSE = await axios.get(`/clinic/consultation/patient/historia_clinica/${this.pacienteId}`);
        this.listaTabla = RESPONSE.data.data.sort((a, b) => b.numero - a.numero);
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    async cargarProductos() {
      try {
        const RESPONSE = await axios.get(
          `/inventario/salidaProducto/entrega-producto/get-details/${this.ordenTrabajoData.orden_trabajo.insumo_id}`,
          {
            params: {
              origen_type: 'V',
              origen_id: this.ordenTrabajoData.data_venta.id,
            },
          },
        );
        this.productos = RESPONSE.data.data.detalles;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    formatDate(fecha) {
      if (!fecha) return '';
      const [year, month, day] = fecha.split('-');
      return `${day}/${month}/${year}`;
    },
    async getServicioComplementario(item) {
      try {
        const RESPONSE = await axios.get(`clinic/consulta_externa/${item}/get_categoria_servicio_complementarios`);
        this.itemServicio = RESPONSE.data.data.categoria_servicio_complementarios;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    openModalPrint(item) {
      this.selectedId = item;
      this.getServicioComplementario(item.consulta_id).then(() => {
        this.$bvModal.show('modalPrintConsultaExterna');
      });
    },
    async getServicioResumen() {
      try {
        const RESPONSE = await axios.get(`clinic/consultation/patient/historia_resumen/${this.pacienteId}`);
        this.itemResumenes = RESPONSE.data.data;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    agregarProducto() {
      if (this.nuevoProducto.producto && this.nuevoProducto.cantidad && this.nuevoProducto.unidad) {
        this.listaProductos.push({ ...this.nuevoProducto });
        this.nuevoProducto = {
          producto: '',
          almacen: '',
          lote: '',
          cantidad: '',
          unidad: '',
        };
      } else {
        util.showNotify('Por favor, complete todos los campos del producto.', 'warning');
      }
    },
    eliminarProducto(index) {
      this.listaProductos.splice(index, 1);
      this.emitirDetalles();
    },
    emitirDetalles() {
      const detalles = this.listaTablaInsumos.map((prod) => ({
        id: prod.id_detalle || 0, // 0 para nuevos productos
        producto_id: prod.id,
        produccto_nombre: prod.Producto,
        descripcion: prod.descripcion,
        cantidad: prod.cantidad,
        lote_id: prod.lote_id || null,
        tc: prod.tc || null,
        estado: prod.estado !== false,
        is_insumo: prod.is_insumo ?? 0,
        salida_producto_id: prod.salida_producto_id || 0,
        total: prod.total || null,
        unidad_medida_id: prod.unidad_id || null,
        lote_numero: prod.lote || null,
        costo_unitario: prod.costo_unitario || null,
      }));

      this.$emit('listaDetalles', detalles);
    },
    abrirModalProducto() {
      this.showProductoModal = true;
    },
    seleccionarProducto(producto) {
      this.productoSelected = producto;

      const unidadAbrev = producto.unidad_medida_abreviatura || producto.unidad_medida;
      const existente = this.listaTablaInsumos.find(
        (item) => item.id === producto.medicamento_id
          && item.unidad_id === producto.unidad_medida_id
          && item.estado !== false,
      );
      if (existente) {
        util.showNotify(`El producto "${producto.medicamento_nombre}" con la misma unidad ya está en la lista`, 'warn');
        this.showProductoModal = false;
        return;
      }
      this.listaTablaInsumos.push({
        id: producto.medicamento_id,
        id_detalle: 0,
        Producto: producto.medicamento_nombre,
        descripcion: producto.descripcion,
        lote: producto.lote,
        lote_id: producto.lote_id || null,
        cantidad: producto.cantidad,
        unidad_id: producto.unidad_medida_id,
        unidad: unidadAbrev,
        usar_unidad_secundaria: producto.usar_unidad_secundaria || false,
        conversiones: producto.conversiones || 1,
        estado: true,
        is_insumo: 0,
        salida_producto_id: 0,
      });

      this.showProductoModal = false;
      util.showNotify(`Producto "${producto.medicamento_nombre}" agregado exitosamente`, 'success');

      this.emitirDetalles();
    },
    async verificarStock() {
      if (!this.almacenSelected) {
        util.showNotify('Debe seleccionar un almacén', 'warning');
        return;
      }

      const itemsActivos = this.listaTablaInsumos.filter((item) => item.estado !== false);

      if (itemsActivos.length === 0) {
        util.showNotify('No hay productos para verificar', 'warning');
        return;
      }

      this.loadingVerificarStock = true;
      try {
        const detalles = itemsActivos.map((prod) => ({
          producto_id: prod.id,
          cantidad: prod.cantidad,
          unidad_medida: prod.unidad_id,
        }));

        const params = {
          almacen_id: this.almacenSelected.id,
        };

        detalles.forEach((detalle, index) => {
          params[`detalles[${index}][producto_id]`] = detalle.producto_id;
          params[`detalles[${index}][cantidad]`] = detalle.cantidad;
          params[`detalles[${index}][unidad_medida_id]`] = detalle.unidad_medida;
        });

        const RESPONSE = await axios.get(
          '/inventario/salidaProducto/entrega-producto/verfic-stock',
          { params },
        );

        const responseData = RESPONSE.data.data;
        const stockLotes = responseData.stockLotes
          || responseData.stock_lotes
          || responseData;

        this.listaTablaInsumos = itemsActivos.map((insumo) => {
          const stockProducto = stockLotes.find(
            (s) => s.producto_id === insumo.id,
          );

          if (stockProducto && stockProducto.lotes && stockProducto.lotes.length > 0) {
            const conversiones = stockProducto.conversion
              || insumo.conversiones
              || 1;
            const conversionFactor = insumo.usar_unidad_secundaria ? conversiones : 1;
            const distribucion = this.distribuirLotesFIFO(
              stockProducto.lotes,
              insumo.cantidad,
              conversionFactor,
            );

            const saldoDisponible = insumo.usar_unidad_secundaria
              ? Math.round((stockProducto.saldo_up || 0) * conversiones)
              : (stockProducto.saldo_up || 0);

            const primerLoteTomado = distribucion.lotesPorTomar[0];
            return {
              ...insumo,
              conversiones,
              lotes: stockProducto.lotes,
              lotesPorTomar: distribucion.lotesPorTomar,
              loteSeleccionado: primerLoteTomado ? primerLoteTomado.lote : null,
              lote: primerLoteTomado ? primerLoteTomado.lote.lote_numero : '',
              lote_id: primerLoteTomado ? primerLoteTomado.lote.lote_id : null,
              fecha_vencimiento: primerLoteTomado
                ? primerLoteTomado.lote.fecha_vencimiento : null,
              saldo_disponible: saldoDisponible,
              faltante: distribucion.faltante,
            };
          }
          return {
            ...insumo,
            lotes: [],
            lotesPorTomar: [],
            loteSeleccionado: null,
            fecha_vencimiento: null,
            saldo_disponible: 0,
            faltante: insumo.cantidad,
          };
        });

        this.stockVerificado = true;
        this.emitirDetalles();

        await this.guardarDetallesOrden();

        util.showNotify('Stock verificado correctamente', 'success');
      } catch (error) {
        util.showNotify(error.response?.data?.message || 'Error al verificar stock', 'error');
      } finally {
        this.loadingVerificarStock = false;
      }
    },
    async guardarDetallesOrden() {
      try {
        const ordenTrabajoId = this.ordenTrabajoData?.orden_trabajo?.id;
        if (!ordenTrabajoId) {
          console.warn('No se encontró el ID de la orden de trabajo');
          return;
        }

        const detallesPayload = this.listaTablaInsumos.map((item) => ({
          id: item.id_detalle || 0,
          tipo_producto_id: item.id,
          cantidad: item.cantidad,
          unidad_medida_id: item.unidad_id,
          lote_id: item.lote_id || null,
          is_insumo: item.is_insumo ?? 0,
          estado: item.estado !== false,
        }));

        const payload = {
          orden_trabajo_id: ordenTrabajoId,
          detalles: detallesPayload,
        };

        const response = await axios.post(
          '/clinic/orden_trabajo/store_detalle',
          payload,
        );

        if (response.data?.data?.orden_trabajo_detalles) {
          const detallesResponse = response.data.data.orden_trabajo_detalles;

          this.listaTablaInsumos = this.listaTablaInsumos.map((item) => {
            const detalleApi = detallesResponse.find(
              (d) => d.tipo_producto_id === item.id
                && (d.lote_id === item.lote_id || (!d.lote_id && !item.lote_id)),
            );

            if (detalleApi) {
              return {
                ...item,
                id_detalle: detalleApi.id,
                lote: detalleApi.lote_numero || item.lote,
                lote_id: detalleApi.lote_id || item.lote_id,
              };
            }
            return item;
          });

          this.emitirDetalles();
        }
      } catch (error) {
        console.error('Error al guardar detalles de la orden:', error);
        util.showNotify(
          error.response?.data?.message || 'Error al guardar los detalles',
          'error',
        );
      }
    },
    async abrirModalInsumo() {
      try {
        this.insumoActivo = true;
        this.stockVerificado = false;
        await this.cargarProductos();
        const nuevosProductos = this.productos.map((producto) => ({
          id: producto.medicamento_id,
          id_detalle: 0,
          Producto: producto.medicamento_nombre,
          lote: producto.lote || '',
          lote_id: producto.lote_id || null,
          fecha_vencimiento: null,
          cantidad: producto.cantidad,
          unidad_id: producto.unidad_medida_id,
          unidad: producto.unidad_medida,
          usar_unidad_secundaria: producto.unidad_principal === 0,
          conversiones: producto.conversiones,
          estado: true,
          lotes: [],
          loteSeleccionado: null,
          is_insumo: 1,
        }));

        nuevosProductos.forEach((nuevoProducto) => {
          const existente = this.listaTablaInsumos.find(
            (item) => item.id === nuevoProducto.id,
          );
          if (!existente) {
            this.listaTablaInsumos.push(nuevoProducto);
          }
        });

        this.productoExpandido = null;
        this.emitirDetalles();
      } catch (error) {
        this.insumoActivo = false;
        util.showNotify('Error al cargar insumos sugeridos', 'error');
      }
    },
    formatLoteLabel(lote) {
      if (!lote) return '';
      const vencimiento = lote.fecha_vencimiento
        ? ` - Venc: ${this.formatDate(lote.fecha_vencimiento)}`
        : '';
      return `${lote.lote_numero} (Disp: ${lote.disponibles})${vencimiento}`;
    },
    onLoteSeleccionado(index, lote) {
      if (lote) {
        this.listaTablaInsumos[index].lote = lote.lote_numero;
        this.listaTablaInsumos[index].lote_id = lote.lote_id;
        this.emitirDetalles();
      }
    },
    onCantidadChange() {
      this.emitirDetalles();
    },
    eliminarInsumo(item) {
      const index = this.listaTablaInsumos.indexOf(item);
      if (index !== -1) {
        this.listaTablaInsumos[index].estado = false;
        if (this.productoExpandido === index) {
          this.productoExpandido = null;
        }
      }
      this.emitirDetalles();
    },
    toggleLotesProducto(index) {
      if (this.productoExpandido === index) {
        this.productoExpandido = null;
      } else {
        this.productoExpandido = index;
      }
    },
    seleccionarLote(index, lote) {
      this.listaTablaInsumos[index].lote = lote.lote_numero;
      this.listaTablaInsumos[index].lote_id = lote.lote_id;
      this.listaTablaInsumos[index].loteSeleccionado = lote;
      this.listaTablaInsumos[index].fecha_vencimiento = lote.fecha_vencimiento;
      this.emitirDetalles();
    },
    formatearNumero(numero) {
      const num = parseInt(numero, 10) || 0;
      return num.toLocaleString('es-ES');
    },
    formatearDecimal(numero) {
      const num = parseFloat(numero) || 0;
      return num.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    esLoteTomado(item, loteId) {
      if (!item.lotesPorTomar) return false;
      return item.lotesPorTomar.some((lt) => lt.lote_id === loteId);
    },
    getLoteRowClass(item, lote) {
      if (this.esLoteTomado(item, lote.lote_id)) {
        return 'table-success';
      }
      return '';
    },
    getRowClass(item) {
      if (item.faltante > 0) {
        return 'table-danger';
      }
      if (item.origen === 'Insumo') {
        return 'table-insumo';
      }
      return '';
    },
    distribuirLotesFIFO(lotes, cantidadRequerida, conversionFactor = 1) {
      const lotesPorTomar = [];
      let restante = cantidadRequerida;

      for (let i = 0; i < lotes.length && restante > 0; i += 1) {
        const lote = lotes[i];
        // disponibles viene en unidad primaria; convertir a unidad seleccionada
        const disponible = (Number(lote.disponibles) || 0) * conversionFactor;

        if (disponible > 0) {
          const tomar = Math.min(restante, disponible);
          lotesPorTomar.push({
            lote,
            cantidad: tomar,
            lote_id: lote.lote_id,
            lote_numero: lote.lote_numero,
          });
          restante -= tomar;
        }
      }

      return {
        lotesPorTomar,
        faltante: restante > 0 ? restante : 0,
        totalAsignado: cantidadRequerida - restante,
      };
    },
    async entregarProductos() {
      if (!this.puedeEntregar) {
        util.showNotify('No se puede entregar, verifique los datos', 'warning');
        return;
      }

      const conFaltante = this.listaTablaInsumos.filter((i) => i.faltante > 0);
      if (conFaltante.length > 0) {
        util.showNotify(
          'Algunos productos no tienen stock suficiente',
          'warning',
        );
        return;
      }

      this.loadingEntregarProductos = true;
      try {
        const detalles = [];
        let totalGeneral = 0;
        const pendientes = this.listaTablaInsumos.filter(
          (item) => !item.salida_producto_id,
        );

        pendientes.forEach((insumo) => {
          if (insumo.lotesPorTomar && insumo.lotesPorTomar.length > 0
            && insumo.lotesPorTomar[0].lote) {
            insumo.lotesPorTomar.forEach((loteTomado) => {
              const rawCosto = loteTomado.lote?.costo_unitario || 0;
              const conversionLote = loteTomado.lote?.conversiones || insumo.conversiones || 1;
              const costoUnitario = insumo.usar_unidad_secundaria
                ? Number(rawCosto) / conversionLote
                : Number(rawCosto);
              const { cantidad } = loteTomado;
              const total = cantidad * costoUnitario;
              totalGeneral += total;

              detalles.push({
                id: insumo.id_detalle || 0,
                tc: loteTomado.lote?.tc || null,
                lote_id: loteTomado.lote_id,
                lote_numero: loteTomado.lote_numero,
                producto_id: insumo.id,
                produccto_nombre: insumo.Producto,
                unidad_medida_id: insumo.unidad_id,
                descripcion: insumo.descripcion,
                is_insumo: insumo.is_insumo,
                estado: insumo.estado !== false,
                cantidad,
                costo_unitario: String(costoUnitario),
                total,
                tratamiento_receta_id: null,
                salida_producto_id: insumo.salida_producto_id,
              });
            });
          } else if (insumo.lote_id) {
            detalles.push({
              id: insumo.id_detalle || 0,
              tc: null,
              lote_id: insumo.lote_id,
              lote_numero: insumo.lote || '',
              producto_id: insumo.id,
              produccto_nombre: insumo.Producto,
              unidad_medida_id: insumo.unidad_id,
              descripcion: insumo.descripcion,
              is_insumo: insumo.is_insumo,
              cantidad: insumo.cantidad,
              estado: insumo.estado !== false,
              costo_unitario: '0',
              total: 0,
              tratamiento_receta_id: null,
              salida_producto_id: insumo.salida_producto_id,
            });
          }
        });

        const today = new Date();
        const fecha = today.toISOString().split('T')[0];

        const cuentaContableId = this.almacenSelected?.cuenta_contable_id
          || this.ordenTrabajoData?.cuenta_contable_id
          || null;
        const dataJson = {
          clasificacion_cie_id: this.clasificacionCie?.id || null,
          subclasificacion_cie_id: this.subclasificacionCie?.id || null,
          diagnostico: this.diagnostico || '',
          conclusion: this.conclusion || '',
          enlace_informacion: this.enlaceInformacion || '',
          medico_id: this.medico_id,
          estado_orden_id: this.ordenTrabajoData?.estado_orden_id || 1,
          almacen_id: this.almacenSelected?.id || null,
          cierre: this.cierre,
          detalles,
          imagenes_eliminar: this.imagenesEliminar || [],
          files: null,
        };

        const payload = {
          fecha,
          almacen_id: this.almacenSelected.id,
          moneda_id: 6,
          numero_orden: null,
          persona_id: this.pacienteId,
          cuenta_contable_id: cuentaContableId,
          detalles,
          glosa: '',
          total: totalGeneral,
          centro_costos: [],
          lugares_uso_salida_producto: [],
          solicitud_id: null,
          venta_detalle_id: this.ordenTrabajoData?.venta_detalle_id
            || this.ordenTrabajoData?.data_venta?.venta_detalle_id || null,
          origen_type: 'OT_CLINIC',
          origen_id: this.ordenTrabajoData?.orden_trabajo.id || null,
          dataJsonOrdenTrabajo: JSON.stringify(dataJson),
        };

        await axios.post(
          '/inventario/salidaProducto/entrega-producto/store',
          payload,
        );

        util.showNotify('Entrega realizada correctamente', 'success');

        this.stockVerificado = false;
        this.insumoActivo = false;

        this.$emit('entregado');
      } catch (error) {
        const message = error.response?.data?.message
          || 'Error al realizar la entrega';
        util.showNotify(message, 'error');
      } finally {
        this.loadingEntregarProductos = false;
      }
    },
  },
};
</script>

  <style>
.custom-tabs-ce .nav-tabs {
  background-color: white !important;
  border-bottom: 2px solid #ddd;
}

.custom-tabs-ce .nav-link {
  color: black !important;
  background-color: transparent !important;
}

.custom-tabs-ce .nav-link.active {
  background-color: white !important;
  border-color: #ddd #ddd white;
}
.bordeResumen {
    border: #dee2e6 solid 1px;
    font-size: 11px;
}

/* Styles for almacen selector */
.almacen-selector {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 15px;
    border: 1px solid #dee2e6;
}

.almacen-selector label {
    font-weight: bold;
    color: #495057;
    margin-bottom: 8px;
}

/* Multiselect customization */
.multiselect {
    border: 1px solid #ced4da;
    border-radius: 4px;
    min-height: 38px;
}

.multiselect--active {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.multiselect__tags {
    border: none;
    background: white;
    padding: 8px 12px;
    min-height: 38px;
}

.multiselect__single {
    color: #495057;
    font-size: 14px;
}

/* New styles for product input form */
.orange-input-band {
    background-color: #f59e6c; /* Golden color for the band */
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.input-label {
    font-weight: bold;
    margin-bottom: 5px;
    display: block;
}

.product-input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;
}

.add-product-btn {
    background-color: #4CAF50; /* Darker green for the button */
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: background-color 0.3s ease;
}

.add-product-btn:hover {
    background-color: #388E3C; /* Even darker green on hover */
}

.grey-header-band {
    background-color: #f0f0f0; /* Light grey background for header */
    padding: 10px 15px;
    border-radius: 8px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.grey-header-band .row {
    margin-bottom: 0; /* Remove default margin-bottom */
}

.grey-header-band .col-3 {
    font-weight: bold;
    color: #333;
}

.table-data-section {
    background-color: white; /* White background for the table data */
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.product-row {
    border-bottom: 1px solid #eee; /* Separator between rows */
    padding: 10px 0;
}

.product-row:last-child {
    border-bottom: none; /* No separator for the last row */
}

.edit-icon {
    margin-right: 8px;
}

.empty-state {
    padding: 20px;
    text-align: center;
    color: #888;
}

.empty-state i {
    font-size: 4rem;
    margin-bottom: 10px;
}

/* Estilo para botón morado activo */
.btn-purple {
    background-color: #6f42c1;
    border-color: #6f42c1;
    color: white;
}

.btn-purple:hover {
    background-color: #5a32a3;
    border-color: #5a32a3;
    color: white;
}

.btn-purple:focus,
.btn-purple:active {
    background-color: #5a32a3;
    border-color: #5a32a3;
    color: white;
    box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);
}

/* Estilo para filas de productos de Insumo (verde agua) */
.table-insumo {
    background-color: #d1f2eb !important;
}

.table-insumo:hover {
    background-color: #a3e4d7 !important;
}
</style>
